
import {
  computed, defineComponent, ref, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useDriveStore } from '../store/driveStore';
import { useMainStore } from '@/store/mainStore';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import ItemMixed from './items/ItemMixed.vue';
import UsePagination from '@/composables/UsePagination';
import { DIRECTION } from '@/helpers/isScrollEnd';
import { IMixedData } from '@/types/interfaces';
import DriveService from '../services/DriveService';

export default defineComponent({
  components: {
    AppItemWrapper,
    ItemMixed,
  },
  props: {
    mixedData: { type: Object as () => IMixedData[], required: true },
    isPageLoading: { type: Boolean, default: false },
    dataLoading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();
    const router = useRouter();

    const isNetwork = computed(() => route.meta.isNetwork);

    function viewAllFiles() {
      if (isNetwork.value) {
        router.push('/drive/network/files');
      } else {
        router.push('/drive/my/files');
      }
    }

    function removeFromSearch(id: string) {
      emit('removeFromSearch', id);
    }

    return {
      driveStore,
      viewAllFiles,
      removeFromSearch,
      isNetwork,
      mainStore,
    };
  },
});
